(function () {
  var STORY_DURATION = 3500;

  function initProductStories(root) {
    if (!root || root.dataset.storiesInitialized === 'true') return;
    root.dataset.storiesInitialized = 'true';

    var container = root.querySelector('[data-stories-track]');
    var modal = root.querySelector('[data-stories-modal]');
    var videoElement = root.querySelector('[data-stories-modal-video]');

    if (!container || !modal || !videoElement) return;

    var items = Array.from(container.querySelectorAll('[data-story-item]'));
    if (!items.length) return;

    var currentIndex = 0;
    var animationId = null;
    var startTime = null;

    function stopRing() {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
      startTime = null;
    }

    function handleLinkNavigation(item) {
      var link = item.dataset.storyLink || '';
      var target = item.dataset.storyLinkTarget || '_self';
      if (!link) return false;

      if (target === '_blank') {
        window.open(link, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = link;
      }

      return true;
    }

    function openStoryModal(item, index) {
      var action = item.dataset.storyAction || 'play_video';
      var videoUrl = item.dataset.storyVideo || '';

      if (action === 'open_link') {
        if (handleLinkNavigation(item)) return;
      }

      if (!videoUrl) {
        handleLinkNavigation(item);
        return;
      }

      currentIndex = index;

      videoElement.src = videoUrl;
      videoElement.load();
      modal.classList.add('active');
      stopRing();

      videoElement.muted = false;
      var playPromise = videoElement.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          videoElement.muted = true;
          videoElement.play().catch(function () {});
        });
      }
    }

    function startRing(index, fromProgress) {
      stopRing();
      if (!items.length) return;

      items.forEach(function (item, itemIndex) {
        var progress = item.querySelector('.ring-progress');
        if (!progress) return;
        if (itemIndex !== index) {
          progress.style.strokeDashoffset = progress._perimeter;
        }
      });

      currentIndex = index;

      var progressElement = items[index].querySelector('.ring-progress');
      if (!progressElement) return;

      var perimeter = progressElement._perimeter;
      var from = fromProgress || 0;
      var elapsed = from * STORY_DURATION;
      startTime = performance.now() - elapsed;

      function tick(now) {
        var delta = now - startTime;
        var fraction = Math.min(delta / STORY_DURATION, 1);
        var offset = perimeter * (1 - fraction);
        progressElement.style.strokeDashoffset = offset;

        if (fraction < 1) {
          animationId = requestAnimationFrame(tick);
          return;
        }

        if (items.length === 1) {
          startRing(0);
        } else {
          startRing((currentIndex + 1) % items.length);
        }
      }

      animationId = requestAnimationFrame(tick);
    }

    function closeStoryModal() {
      modal.classList.remove('active');
      videoElement.pause();
      videoElement.removeAttribute('src');
      videoElement.load();
      startRing(currentIndex);
    }

    items.forEach(function (item, index) {
      var progress = item.querySelector('.ring-progress');
      var thumbVideo = item.querySelector('.widde-video-thumb');

      if (progress) {
        progress.setAttribute('pathLength', '100');
        progress.style.strokeDasharray = '100';
        progress.style.strokeDashoffset = '100';
        progress._perimeter = 100;
      }

      if (thumbVideo) {
        thumbVideo.muted = true;
        thumbVideo.playsInline = true;

        var playThumb = thumbVideo.play();
        if (playThumb && typeof playThumb.catch === 'function') {
          playThumb.catch(function () {});
        }
      }

      item.addEventListener('click', function () {
        if (item.disabled) return;
        openStoryModal(item, index);
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-stories-close') || event.target === modal) {
        closeStoryModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('active')) {
        closeStoryModal();
      }
    });

    startRing(0);
  }

  function initAllProductStories(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-stories]').forEach(initProductStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductStories(document);
    });
  } else {
    initAllProductStories(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductStories(event.target);
  });
})();
